"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";

export default function UtmSessionStorage() {
    const searchParams = useSearchParams();

    useEffect(() => {
        // Persist all UTM params to sessionStorage using an utm_ key prefix.
        for (const [key, value] of searchParams.entries()) {
            if (!key.toLowerCase().startsWith("utm_")) continue;

            const storageKey = key.toLowerCase().startsWith("utm_")
                ? key.toLowerCase()
                : `utm_${key.toLowerCase()}`;

            sessionStorage.setItem(storageKey, value);
        }
    }, [searchParams]);

    return null;
}
